import React, { createContext, useContext, useState, useEffect } from 'react';

// 1. Context 생성
const DirtyFormContext = createContext();

// 2. Provider 컴포넌트 생성
export const DirtyFormProvider = ({ children }) => {
  const [isDirty, setIsDirty] = useState(false);
  const [message, setMessage] = useState('저장되지 않은 변경 사항이 있습니다.');
  const [navigationLock, setNavigationLock] = useState(null);

  useEffect(() => {
    // (기존 기능) 탭 닫기/새로고침 방지
    const handleBeforeUnload = (e) => {
      if (navigationLock || isDirty) {
        e.preventDefault();
        e.returnValue = navigationLock || message;
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [isDirty, message, navigationLock]);

  const value = {
    isDirty,
    setIsDirty,
    setDirtyMessage: setMessage,
    navigationLock,
    setNavigationLock,
  };

  return (
    <DirtyFormContext.Provider value={value}>
      {children}
    </DirtyFormContext.Provider>
  );
};

// 3. Custom Hook (간편하게 사용하기 위함)
export const useDirtyForm = () => {
  const context = useContext(DirtyFormContext);
  if (!context) {
    throw new Error('useDirtyForm must be used within a DirtyFormProvider');
  }
  return context;
};
